<template>
  <div>
    <form-modal
      :id="objeto.rubrica"
      titulo-botao="Inserir despesa"
      :titulo-modal="objeto.titulo"
      titulo-tabela-imutavel="Planejado"
      :colunas-imutaveis="colunas"
      :dados-imutaveis="propostaCalculada"
      titulo-tabela-mutavel="Realizado"
      :colunas-mutaveis="colunasRealizado"
      :dados-mutaveis="projetoCalculado"
      ref="modalForm"
      :criar="permissao.c && projetoEditavel"
      :ler="permissao.r"
      :atualizar="permissao.u"
      :remover="permissao.d && projetoEditavel"
      :somente-ok="!projetoEditavel"
      :ok-vira-cancelar="!projetoEditavel"
      controles
      @ok="salvar"
      @cancel="limpar"
      @edit="editar"
      @remove="deletar"
      @baixarComprovantes="baixarComprovantes"
    >
      <template #titulo-modal>
        <div>
          <span class="mr-2">
            {{ objeto.titulo }}
          </span>

          <b-badge> Total previsto: </b-badge>
          <b-badge class="ml-2" variant="light">
            {{ totalPrevisto }}
          </b-badge>

          <b-badge variant="warning" class="ml-4"> Total realizado: </b-badge>
          <b-badge class="ml-2" variant="light">
            {{ totalRealizado }}
          </b-badge>

          <b-badge variant="success" class="ml-4"> Total restante: </b-badge>
          <b-badge class="ml-2" variant="light">
            {{ totalRestante }}
          </b-badge>
        </div>
      </template>
      <template #modal>
        <modal-rubricas
          :form="form"
          :projeto-id="projetoId"
          :projeto-id-base="projetoIdBase"
          ref="modal"
        />
      </template>
    </form-modal>
  </div>
</template>
<script>
import FormModal from "../componentes/FormModal";
import helpers from "@/common/utils/helpers";
import cloneDeep from "lodash/cloneDeep";
import ProjetoService from "@/common/services/projeto/projeto.service";
import ModalRubricas from "../componentes/ModalRubricas";
import { AlertasMixin } from "@/common/mixins/AlertasMixin";

import { START_LOADING, STOP_LOADING } from "@/store/Store";
export default {
  mixins: [AlertasMixin],
  components: {
    FormModal,
    ModalRubricas,
  },
  props: {
    projetoId: {
      type: String,
      required: true,
    },
    projetoIdBase: {
      type: String,
      required: true,
    },
    nomeIdProjeto: {
      type: String,
      required: true,
    },
    endpointProposta: {
      type: String,
      required: true,
    },
    objeto: {
      type: Object,
      default: () => ({
        tipo: "tipoServico",
        rubrica: "",
        titulo: "Generico",
      }),
    },
    chavePermissao: {
      type: String,
      default: "",
    },
    projeto: {
      required: true,
    },
    projetoEditavel: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    empresas: [],
    form: {
      projetoEmpresaInvestidoraId: null,
      descricao: null,
      justificativa: null,
      quantidade: 0,
      valorIndividual: "",
      origemDespesa: null,
      despesaLaboratorioExistente: null,
      despesaLaboratorioNovo: null,
      dataEmissao: null,
      tipoDocumento: 0,
      numeroDocumento: null,
      documento: null,
      cpfcnpj: null,
      invoice: null,
      comprovante: {
        base64: null,
      },
      liquidacaoFinanceira: {
        base64: null,
      },
    },
    colunas: [],
    colunasRealizado: [],
    proposta: [],
    realizado: [],
  }),
  mounted() {
    this.colunas = [
      {
        key: this.objeto.tipo,
        label: "Tipo",
        formatter: (value) => {
          if (value) return helpers.getEnum(value).text;
        },
      },
      { key: "detalhamento", label: "Detalhamento" },
      { key: "justificativa", label: "Justificativa" },
      {
        key: "mesDespesa",
        label: "Mês previsto",
        formatter: (a, b, c) => {
          if (c[this.objeto.tipo] == -1) return "";
          return this.meses.find((el) => el.value === c.mesDespesa)
            ? this.meses.find((el) => el.value === c.mesDespesa).text
            : c.mesDespesa;
        },
      },
      {
        key: "valor",
        label: "Custo",
        formatter: (value) => {
          if (value) return helpers.formatarValor(value);
        },
      },
    ];

    this.colunasRealizado = [
      {
        key: "projetoEmpresaInvestidoraId",
        label: "Empresa investidora",
        formatter: (value) => {
          if (value == -1) return "Total";
          let empresa = this.empresas.find((el) => el.value == value);
          return empresa ? empresa.text : "";
        },
      },
      {
        key: "dataEmissao",
        label: "Data",
        formatter: (value) => {
          if (value) return helpers.formatarDataBr(value);
        },
      },
      {
        key: "tipoDocumento",
        label: "Tipo de doc.",
        formatter: (value) => {
          if (value) return helpers.getEnum(value).text;
        },
      },
      { key: "numeroDocumento", label: "Nº doc." },
      { key: "descricao", label: "Descrição" },
      { key: "beneficiado", label: "Beneficiado" },
      {
        key: "valorIndividual",
        label: "Valor total",
        formatter: (value, label, item) => {
          if (item.projetoEmpresaInvestidoraId == -1)
            return helpers.formatarValor(item.valorIndividual);
          if (value)
            return helpers.formatarValor(
              item.valorIndividual * item.quantidade
            );
        },
      },
      { key: "actions", label: "Ações" },
    ];

    this.buscar();
    this.buscarProposta();
  },
  methods: {
    baixarComprovantes: function () {
      ProjetoService.baixarComprovanteRubricas(
        this.projetoId,
        this.objeto.rubrica
      )
        .then((res) => {
          const blob = new Blob([res.data], { type: "application/zip" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `comprovantes_${this.objeto.rubrica}.zip`;
          link.click();
        })
        .catch((err) => {
          if (err.response.status == 400) {
            this.alertaErro(err.response.data.errors);
          } else this.alertaErro("Erro ao baixar");
        });
    },
    salvar: function () {
      let form = cloneDeep(this.form);
      if (!this.$refs.modal.validateState()) {
        return;
      }

      if (!form.documento && form.origemDespesa == "Nacional") {
        this.alertaErro("Preencha o CPF/CNPJ");
        return;
      }

      if (!form.cpfcnpj && form.origemDespesa == "Nacional") {
        this.alertaErro("Preencha o documento");
        return;
      }

      // if (!form.invoice && form.origemDespesa == "Internacional" ) {
      //     this.alertaErro('Preencha o invoice');
      //     return;
      // }

      form = Object.assign({}, form, form.empresaObj);

      this.confirmar("Aviso", "Deseja salvar custo?").then((confirmado) => {
        if (confirmado) {
          if (form.dataEmissao.indexOf("/") > -1) {
            form.dataEmissao = helpers.formatarDataBD(form.dataEmissao);
          }
          form.valorIndividual = helpers.removerValor(form.valorIndividual);
          if (form.origemDespesa == "Nacional")
            form.cpfcnpj = form.cpfcnpj.replace(/[^0-9]/g, "");
          form[this.nomeIdProjeto] = this.projetoId;

          this.$store.dispatch(START_LOADING);
          ProjetoService.salvarGenerico(this.objeto.rubrica, form)
            .then(() => {
              this.alertaSucesso("Custo salvo com sucesso!").then(() => {
                this.$refs.modalForm.closeModal();
                this.buscar();
              });
            })
            .catch((err) => {
              if (err.response.status == 400) {
                this.alertaErro(err.response.data.errors);
              } else this.alertaErro("Erro ao salvar");
            })
            .finally(() => {
              this.$store.dispatch(STOP_LOADING);
            });
        }
      });
    },

    deletar: function (item) {
      this.confirmar("Aviso", "Deseja realmente excluir?").then(
        (confirmado) => {
          if (confirmado) {
            this.$store.dispatch(START_LOADING);
            ProjetoService.deletarGenerico(this.objeto.rubrica, item.id)
              .then(() => {
                this.alertaSucesso("Excluido com sucesso!");
                this.buscar();
              })
              .catch((err) => {
                if (err.response.status == 400) {
                  this.alertaErro(err.response.data.errors);
                } else this.alertaErro("Erro ao excluir");
              })
              .finally(() => {
                this.$store.dispatch(STOP_LOADING);
              });
          }
        }
      );
    },

    editar: function (item) {
      let form = cloneDeep(item);
      form.valorIndividual = helpers.formatarValor(form.valorIndividual);
      form.dataEmissao = helpers.formatarDataBr(form.dataEmissao);
      form.empresa = form.projetoEmpresaInvestidoraId;
      form.empresaObj = this.empresas.find(
        (el) => el.value == form.projetoEmpresaInvestidoraId
      ).el;
      if (!form.liquidacaoFinanceira)
        form.liquidacaoFinanceira = {
          base64: null,
        };

      if (!form.comprovante)
        form.comprovante = {
          base64: null,
        };
      this.form = form;
      this.$refs.modalForm.openModal();
    },

    limpar: function () {
      this.form = {
        projetoEmpresaInvestidoraId: null,
        descricao: null,
        justificativa: null,
        quantidade: 0,
        valorIndividual: "",
        origemDespesa: null,
        despesaLaboratorioExistente: null,
        despesaLaboratorioNovo: null,
        dataEmissao: null,
        tipoDocumento: 0,
        numeroDocumento: null,
        documento: null,
        cpfcnpj: null,
        invoice: null,
        comprovante: {
          base64: null,
        },
        liquidacaoFinanceira: {
          base64: null,
        },
      };
    },

    buscar: function () {
      ProjetoService.listarEmpresasInvestidoras(this.projetoIdBase).then(
        (response) => {
          this.empresas = response.data.data.map((el) => {
            return {
              value:
                el.projetoInvestidoraId || el.projetoCooperadaInvestidoraId,
              text: el.razaoSocial,
              el: el,
            };
          });
        }
      );

      this.$store.dispatch(START_LOADING);
      ProjetoService.listarGenerico(
        this.objeto.rubrica,
        this.projetoId,
        this.nomeIdProjeto
      )
        .then((response) => {
          this.realizado = response.data.data.itens;
        })
        .catch(() => {
          this.alertaErro("Erro ao buscar");
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    buscarProposta: function () {
      ProjetoService.buscarRubricaProposta(
        this.endpointProposta,
        this.objeto.rubrica,
        this.projetoId
      )
        .then((response) => {
          this.proposta = response.data.data || [];
        })
        .catch(() => {
          this.alertaErro("Erro ao buscar");
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
  },
  computed: {
    meses() {
      if (!this.projeto.dataInicio) return [];
      return helpers.criarArrayMes(
        this.projeto.dataInicio,
        this.projeto.duracao,
        false
      );
    },
    permissao() {
      return this.$store.getters["app/retornaPermissao"](this.chavePermissao);
    },
    totalPrevisto: function () {
      return helpers.formatarValor(
        this.proposta.reduce((total, el) => total + el.valor, 0)
      );
    },
    totalRealizado: function () {
      let formulario =
        this.form.quantidade * helpers.removerValor(this.form.valorIndividual);
      return helpers.formatarValor(
        this.realizado.reduce((total, el) => {
          if (this.form.id == el.id) return total;
          return total + el.valorIndividual * el.quantidade;
        }, 0) + formulario
      );
    },
    totalRestante: function () {
      let formulario =
        this.form.quantidade * helpers.removerValor(this.form.valorIndividual);
      let totalPrevisto = this.proposta.reduce(
        (total, el) => total + el.valor,
        0
      );
      let totalRealizado = this.realizado.reduce((total, el) => {
        if (this.form.id == el.id) return total;
        return total + el.valorIndividual * el.quantidade;
      }, 0);

      return helpers.formatarValor(
        totalPrevisto - (totalRealizado + formulario)
      );
    },
    propostaCalculada: function () {
      let value = cloneDeep(this.proposta);
      value.push({
        id: -1,
        tipoServico: -1,
        valor: this.proposta.reduce((total, el) => total + el.valor, 0),
        _rowVariant: "warning",
      });
      return value;
    },

    projetoCalculado: function () {
      let value = cloneDeep(this.realizado);
      value.push({
        id: -1,
        projetoEmpresaInvestidoraId: -1,
        valorIndividual: this.realizado.reduce((total, el) => {
          return total + el.valorIndividual * el.quantidade;
        }, 0),
        _rowVariant: "warning",
      });
      return value;
    },
  },
};
</script>
<style lang="">
</style>